import { LOCATIONS_PAGE_SIZE } from './survey-storage';

export function computePageStarts(rowCount: number, breaks: readonly number[] = [], pageSize = LOCATIONS_PAGE_SIZE): number[] {
  const cuts = [...new Set(breaks)].filter((row) => Number.isInteger(row) && row > 0 && row < rowCount).sort((a, b) => a - b);
  const bounds = [0, ...cuts, Math.max(rowCount, 1)];
  const starts: number[] = [];
  for (let i = 0; i < bounds.length - 1; i++) {
    for (let start = bounds[i]; start < bounds[i + 1]; start += pageSize) {
      starts.push(start);
    }
  }
  return starts;
}

export function shiftBreaksAfterRemoval(breaks: readonly number[], removedIndex: number): number[] {
  return breaks.map((row) => (row > removedIndex ? row - 1 : row));
}

export function shiftBreaksAfterInsertion(breaks: readonly number[], insertedAt: number): number[] {
  return breaks.map((row) => (row >= insertedAt ? row + 1 : row));
}

export function normalizePageBreaks(rowCount: number, breaks: readonly number[] = [], pageSize = LOCATIONS_PAGE_SIZE): number[] {
  return computePageStarts(rowCount, breaks, pageSize).slice(1);
}
